import React, { use } from "react";
import type { AnyObject } from "@entrilia/shared/types.ts";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";

import type {
  CreateReportGroup,
  DeleteReportGroupResult,
  GetReportAuthorizationResponse,
  ReportAuthorization,
  ReportGroup,
  ReportGroupsResponse,
  ReportInfo,
} from "../../../../../../api/types/svTypes.ts";
import type { ApiResponse } from "@entrilia/shared/api/types.ts";

export interface GroupsContextType {
  groups: Record<string, ReportGroup[]>;
  ui: { loaded: boolean; error?: string };
  actions: {
    load: (clientCode: string) => Promise<unknown>;
    add: (clientCode: string, group: ReportGroup) => Promise<ReportGroup | undefined>;
    update: (clientCode: string, group: ReportGroup) => Promise<void>;
    delete: (clientCode: string, groupId: string, reassignToGroupId?: string) => Promise<DeleteReportGroupResult>;
    reorder: (clientCode: string, groups: ReportGroup[]) => Promise<void>;
    replace?: (
      clientCode: string,
      fromGroupId: string,
      toGroupId: string,
      reloadReports: () => Promise<void>
    ) => Promise<AnyObject | undefined>;
    reloadReports?: () => Promise<void>;
    fetchAllReportGroups?: (clientCode: string) => Promise<ReportGroupsResponse | undefined>;
    addMany?: (groups: CreateReportGroup[]) => Promise<ReportInfo[] | undefined>;
    getSharing?: (clientCode: string, groupId: string) => Promise<ApiResponse<GetReportAuthorizationResponse>>;
    updateSharing?: (
      clientCode: string,
      groupId: string,
      authorization: ReportAuthorization
    ) => Promise<ApiResponse<ReportGroup>>;
  };
}

export const GroupsContext = React.createContext<GroupsContextType | undefined>(undefined);

export const useGroupsContext = () => {
  const context = use(GroupsContext);
  return defined(context);
};
